import {BackendPlanManager} from 'components/Backend/Plan/Manager';

export const title = '方案管理';
export const orderNum = 1;
export default BackendPlanManager;
